import IndexPage from "..";

export default IndexPage;
